/**
 * @file: sortedServiceSubjectsByType.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { ServiceSubject } from '@euler/model';
import { ServiceSubjectType } from '@euler/model/enum';
import { sorted } from '@euler/utils/array';

const kOrdersByType: { [p in ServiceSubjectType]: number } = {
  [ServiceSubjectType.Inspection]: 0,
  [ServiceSubjectType.Fault]: 1,
  [ServiceSubjectType.Construction]: 2,
  [ServiceSubjectType.Other]: 3,
};

export function sortedServiceSubjectsByType(subjects: ServiceSubject[]) {
  return sorted(subjects, (x, y) =>
    kOrdersByType[x.type] < kOrdersByType[y.type] ? -1 : 1,
  );
}
